import { ArrowDownToLine, ArrowUpRight, Github, Linkedin, Mail, MapPin } from "lucide-react";
import Reveal from "@/components/ui/Reveal";
import { toast } from "sonner";
import ContactForm from "@/components/windows/ContactForm";
import { PROFILE } from "@/data/portfolio";
import { downloadResume } from "@/utils/download";

const LINKS = [
  {
    id: "email",
    label: "Email",
    value: PROFILE.email,
    href: `mailto:${PROFILE.email}`,
    icon: Mail,
    external: false,
  },
  {
    id: "linkedin",
    label: "LinkedIn",
    value: PROFILE.linkedinLabel,
    href: PROFILE.linkedin,
    icon: Linkedin,
    external: true,
  },
  {
    id: "github",
    label: "GitHub",
    value: PROFILE.githubLabel,
    href: PROFILE.github,
    icon: Github,
    external: true,
  },
];

export default function ContactWindow() {
  return (
    <div className="space-y-6 p-6 sm:p-7" data-testid="contact-content">
      <div>
        <p className="eyebrow">./contact.sh --reach-out</p>
        <p className="mt-2 text-sm text-slate-400">
          Building payments, reconciliation or distributed systems? My inbox is always open.
        </p>
        <p className="mt-2 flex items-center gap-1.5 font-mono text-[11px] text-slate-500">
          <MapPin size={11} className="text-sonoma" /> {PROFILE.location} · IST (UTC+5:30)
        </p>
      </div>

      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2" data-testid="contact-links">
        {LINKS.map((l, i) => (
          <Reveal key={l.id} delay={i * 0.05} className="h-full">
            <a
              href={l.href}
              {...(l.external ? { target: "_blank", rel: "noopener noreferrer" } : {})}
              data-testid={`contact-link-${l.id}`}
              className="group flex h-full items-center gap-3.5 rounded-xl border border-white/8 bg-white/[.03] p-4 transition-colors duration-200 hover:border-sonoma/40 hover:bg-white/[.06]"
            >
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-sonoma/15 ring-1 ring-sonoma/25 transition-transform duration-200 group-hover:scale-105">
                <l.icon size={16} className="text-sky-300" />
              </span>
              <span className="min-w-0 flex-1">
                <span className="block font-mono text-[10px] uppercase tracking-widest text-slate-500">{l.label}</span>
                <span className="block truncate text-[13px] text-slate-200">{l.value}</span>
              </span>
              {l.external ? <ArrowUpRight size={14} className="shrink-0 text-slate-500 transition-colors duration-150 group-hover:text-sky-300" /> : null}
            </a>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.15}>
        <button
          onClick={() => {
            downloadResume();
            toast("Resume downloading — AnishResume_WA.pdf");
          }}
          data-testid="contact-resume-btn"
          className="flex w-full items-center justify-center gap-2 rounded-xl border border-white/12 bg-white/5 px-4 py-3 font-mono text-xs font-medium text-slate-200 transition-colors duration-150 hover:bg-white/10"
        >
          <ArrowDownToLine size={14} /> prefer the classic route? download the resume — AnishResume_WA.pdf
        </button>
      </Reveal>

      <Reveal delay={0.2}>
        <ContactForm />
      </Reveal>
    </div>
  );
}
